// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICipAccountClosureDelayDaysPropertyDto
 */
export interface ICipAccountClosureDelayDaysPropertyDto {
    /**
     * 
     * @type {number}
     * @memberof ICipAccountClosureDelayDaysPropertyDto
     */
    cip_account_closure_delay_days?: number;
    /**
     * 
     * @type {string}
     * @memberof ICipAccountClosureDelayDaysPropertyDto
     */
    cip_account_closure_delay_days_state?: ICipAccountClosureDelayDaysPropertyDtoCipAccountClosureDelayDaysStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum ICipAccountClosureDelayDaysPropertyDtoCipAccountClosureDelayDaysStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the ICipAccountClosureDelayDaysPropertyDto interface.
 */
export function instanceOfICipAccountClosureDelayDaysPropertyDto(value: object): value is ICipAccountClosureDelayDaysPropertyDto {
    return true;
}

export function ICipAccountClosureDelayDaysPropertyDtoFromJSON(json: any): ICipAccountClosureDelayDaysPropertyDto {
    return ICipAccountClosureDelayDaysPropertyDtoFromJSONTyped(json, false);
}

export function ICipAccountClosureDelayDaysPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICipAccountClosureDelayDaysPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'cip_account_closure_delay_days': json['cip_account_closure_delay_days'] == null ? undefined : json['cip_account_closure_delay_days'],
        'cip_account_closure_delay_days_state': json['cip_account_closure_delay_days_state'] == null ? undefined : json['cip_account_closure_delay_days_state'],
    };
}

export function ICipAccountClosureDelayDaysPropertyDtoToJSON(json: any): ICipAccountClosureDelayDaysPropertyDto {
    return ICipAccountClosureDelayDaysPropertyDtoToJSONTyped(json, false);
}

export function ICipAccountClosureDelayDaysPropertyDtoToJSONTyped(value?: ICipAccountClosureDelayDaysPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cip_account_closure_delay_days': value['cip_account_closure_delay_days'],
        'cip_account_closure_delay_days_state': value['cip_account_closure_delay_days_state'],
    };
}

